import { useMolde } from '@/services/workflows2';
import { LivePublishedPreview } from '@/components/ArticleCreator/LivePublishedPreview';

interface MoldeFrameProps {
  siteSlug: string;
}

export function MoldeFrame({ siteSlug }: MoldeFrameProps) {
  const { data: molde, isLoading, error } = useMolde(siteSlug);

  if (isLoading)
    return <div style={{ padding: '16px', color: 'var(--text-1)' }}>Carregando molde...</div>;
  if (error)
    return (
      <div style={{ padding: '16px', color: 'var(--sig-crit-text)' }}>Erro ao carregar molde</div>
    );
  if (!molde) return null;

  if (!molde.disponivel) {
    return <div style={{ padding: '16px', color: 'var(--text-3)' }}>sem molde: {molde.motivo}</div>;
  }

  const siteName = molde.site?.nome;
  const category = molde.categorias?.[0];

  return (
    <div
      className="molde-frame"
      style={{ border: '1px solid var(--border-2)', borderRadius: '8px', overflow: 'hidden' }}
    >
      <LivePublishedPreview title="" bodyHtml="" siteName={siteName} category={category} />
    </div>
  );
}
